const googleEndpoints = {
	authorize: '/oauth/google/authorize',
	identity: '/session/google/identity',
};

const googleIdentityAuthorized = user => user?.googleIdentity?.status === 'active';

export { googleEndpoints, googleIdentityAuthorized };
